/** Interval in ms for auto-refresh when enabled on Game Board / Session Game Board (e.g. 20 seconds). */
export const AUTO_REFRESH_INTERVAL_MS = 5 * 1000;

/** Set to true to show Auto Refresh toggle and allow polling fallback (SignalR replaces this when connected). */
export const GAME_BOARD_AUTO_REFRESH_ENABLED = false;

/** How often to verify SignalR is still Connected and recover if not. */
export const GAME_BOARD_REALTIME_HEALTH_CHECK_MS = 8 * 1000;

export const itemsPerPageOptions = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];
